import { render } from "./CollectionsManager.vue?vue&type=template&id=5e6a217e"
import script from "./CollectionsManager.vue?vue&type=script&lang=js"
export * from "./CollectionsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__